module.exports = __webpack_public_path__ + "img/Photo.0cb471d2.svg";